<template>
  <div>
    <USHeader v-if="pageType != 3 && showUsHeader" @getChildRefs="handleChildRefs" />
    <NewUSHeader v-else-if="pageType != 3 && showNewUsHeader" @getChildRefs="handleChildRefs" />
    <div v-if="pageType != 3 && !showUsHeader && !showNewUsHeader" class="home-wrapper">
      <Header :sticky-status="false" />
    </div>
    <template>
      <div v-for="item in btnComponentList" :key="item.key" class="btn-fixed-wrapper">
        <ButtonGroupFixed
          :component-name="item.content.componentName"
          :component-type="item.content.componentType"
          :component-title="item.content.componentTitle"
          :module-id="item.id"
          v-bind="item.content.componentData"
        />
      </div>
    </template>

    <h1 v-if="!hasMainBanner && pageTitle" class="visually-hidden">
      {{ pageTitle }}
    </h1>

    <DynamicComponent
      v-if="!!componentList.length"
      ref="parentContentRef"
      :class="{'container': !showUsHeader && !showNewUsHeader}"
      :locale="locale"
      :component-list="componentList"
      @components-loaded="onComponentsLoaded"
    />
    <BMFooter v-if="shouldShowFooter && showAllComponents && locale==='bmus'" ref="parentFooter" />
    <UsOnlineWebFooter v-else-if="shouldShowFooter && showAllComponents && showNewUsHeader" ref="parentFooter" />
    <Footer v-else-if="shouldShowFooter && showAllComponents" ref="parentFooter" />
    <ToolsGroup v-if="shouldShowFooter" />
    <no-ssr>
      <CookiesStatement v-if="showCookiesStatement" ref="parentRobot" />
    </no-ssr>
  </div>
</template>

<script>
import DynamicComponent from '@/components/global/DynamicComponents/web'
import Header from '@/components/global/FeatureComponents/Header/web'
import USHeader from '@/components/global/FeatureComponents/USHeader/web'
import NewUSHeader from '@/components/global/FeatureComponents/NewUsHeader/web'
import Footer from '@/components/global/FeatureComponents/Footer/webNew'
import UsOnlineWebFooter from '@/components/global/FeatureComponents/Footer/UsOnlineWeb'
import BMFooter from '@/components/global/FeatureComponents/BMFooter/web'
import ButtonGroupFixed from '~/components/global/DynamicComponents/ButtonGroupFixed/web'
import CookiesStatement from 'components/common/CookiesStatement'
import ToolsGroup from 'components/common/ToolsGroup/index.vue';
import bus from 'common/bus'
import Cookies from 'js-cookie';

export default {
  layout: 'simpleLayout',
  middleware: ['queryCustomPage'],
  components: {
    DynamicComponent,
    Header,
    Footer,
    CookiesStatement,
    ToolsGroup,
    ButtonGroupFixed,
    USHeader,
    BMFooter,
    NewUSHeader,
    UsOnlineWebFooter,
  },
  data() {
    const { locale } = this.$store.state
    return {
      locale,
      showAllComponents: false,
    }
  },
  computed: {
    thinkType() {
      return this.$store.state.thinkType
    },
    componentList() {
      return this.$store.state.customPage.pageModuleList.filter((item) => (item.type !== 49 && item.type !== 66))
    },
    pageType() {
      return this.$store.state.customPage.type
    },
    btnComponentList() {
      let componentList = this.$store.state.customPage.pageModuleList.filter((item) => item.type === 49)
      componentList = componentList.map((item) => {
        const data = {}
        try {
          const v = JSON.parse(item.content)
          data.content = v
        } catch (err) {
          console.log('err is ', err)
        }

        return { ...item, ...data }
      })
      return componentList
    },
    isLogin() {
      return this.$store.state.ucenter.isLogin;
    },
    schoolCode() {
      return this.$store.state.schoolCode;
    },
    shouldShowFooter() {
      return this.pageType !== 3;
    },
    showCookiesStatement() {
      return this.$store.state.locale !== 'hk';
    },
    isGray() {
      return (process.env.grayType || '').toLowerCase() === 'gray';
    },
    showUsHeader() {
      const schoolList = ['415', '8601', '105'];
      console.log('thinkType is ----', this.thinkType);
      // Show US Header if ((not gray && schoolCode is in list && thinkType is 'inperson') || (gray && schoolCode is in list))
      if ((!this.isGray && schoolList.includes(this.schoolCode))
        || (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'inperson')) {
        return true;
      }
      return false;
    },
    showNewUsHeader() {
      // us mars uk ca jp kr fr
      const schoolList = ['415', '8601', '4401', '103', '8101', '8201', '3301']
      console.log('thinkType is ----', this.thinkType)
      if (this.isGray && schoolList.includes(this.schoolCode) && this.thinkType === 'online') {
        return true;
      }
      return false;
    },
    showDefaultHeader() {
      const forbidden = ['415', '8601', '105']
      return !forbidden.includes(this.schoolCode)
    },
    pageTitle() {
      return this.$store?.state?.website?.page?.title || ''
    },
    hasMainBanner() {
      try {
        const list = this.$store.state.customPage.pageModuleList || []
        const filtered = list.filter((item) => item.type !== 49 && item.type !== 66)
        return filtered.some((item) => {
          if (!item) return false
          if (item.content) {
            try {
              const v = JSON.parse(item.content)
              return typeof v.componentName === 'string' && v.componentName.includes('MainBanner')
            } catch (e) {
              return false
            }
          }
          return typeof item.componentName === 'string' && item.componentName.includes('MainBanner')
        })
      } catch (e) {
        return false
      }
    },
  },
  watch: {
    '$route.path': {
      handler: 'onRoutePathChange',
    },
  },
  mounted() {
    // const { verifyKey } = process.env;
    // gRecaptcha.createScript.call(this, verifyKey)
    this.getTrackData()
    this.showDiagnosisUS()
    this.trackGrayHomePageView()
  },
  methods: {
    onRoutePathChange() {
      try {
        this.thinkType = Cookies.get('thinkType') || ''
      } catch (e) {
        this.thinkType = ''
      }
      this.trackGrayHomePageView()
    },
    trackGrayHomePageView() {
      try {
        if (this.isGray && this.$route && this.$route.path === '/') {
          window.dataLayer = window.dataLayer || []
          window.dataLayer.push({ event: 'page_view_gray_gtm' })
        }
      } catch (e) { /* no-op */ }
    },
    getTrackData() {
      const sourceType = this.$route.query.source_type || window.sessionStorage.getItem('source_type') || ''
      const sourceId = this.$route.query.source_id || window.sessionStorage.getItem('source_id') || ''
      this.Sensors.track('component_page_pv', {
        source_id: sourceId,
        source_type: sourceType,
      })
    },
    // 美分 诊断弹窗判断处理
    showDiagnosisUS() {
      if (this.locale === 'us' && this.$route.query.showDiagnosis === '1') {
        if (!this.isLogin) {
          this.$nextTick(() => {
            bus.$emit('login', { triggerSource: 'appointment' });
          })
          return
        }
        this.$nextTick(() => {
          bus.$emit('toShowDiagnosis')
        })
      }
    },
    handleChildRefs(callback) {
      callback({
        element1: this.$refs.parentContentRef,
        element2: this.$refs.parentFooter,
        element3: this.$refs.parentRobot,
      });
    },
    onComponentsLoaded() {
      this.showAllComponents = true;
    },
  },
  head() {
    // 限制弹窗缩放
    if (this.$store.state.locale !== 'ae') return {}
    return {
      link: [{
        hid: 'icon',
        rel: 'icon',
        type: 'image/x-icon',
        href: '/edulogo.ico',
      }],
    }
  },
};
</script>

<style lang="scss" scoped>
.home-wrapper {
  position: sticky;
  top: 0;
  z-index: 1000;
}

.container {
  padding: 40px 0;
}

.visually-hidden {
  position: absolute;
  visibility: hidden;
  height: 0;
}
</style>
<style>
.grecaptcha-badge { visibility: hidden; }
</style>
